import {
  type FC,
  type PropsWithChildren,
  type ReactNode,
  useMemo,
} from 'react';
import { Heading4 } from '@components/typography/Heading4.tsx';
import { InfoText } from '@components/info-text.tsx';
import { classNames } from '@utils/classNames.ts';

export const FormLabel = ({
  label,
  required,
  infoText,
  className,
  valid,
  disabled,
  Component = Heading4,
}: Readonly<
  PropsWithChildren<{
    label: ReactNode;
    required?: boolean;
    infoText?: string;
    valid?: boolean;
    disabled?: boolean;
    className?: string;
    Component?: FC<PropsWithChildren>;
  }>
>) => {
  const textColorClass = useMemo(() => {
    if (disabled) {
      return 'text-slate-400';
    } else if (valid) {
      return 'text-slate-900';
    }
    return 'text-orange-600';
  }, [valid, disabled]);

  return (
    <div className={classNames('flex-wrap items-center', className)}>
      <Component>
        <span className="flex flex-1 mb-1 sm:mb-3">
          <span className={classNames('flex-1', textColorClass)}>
            <span>{label}</span>
            {required && <span>*</span>}
          </span>
          {infoText && <InfoText className="self-end" text={infoText} />}
        </span>
      </Component>
    </div>
  );
};
